import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import NewsList from '../../../../components/News/NewsList';
import NewsPromoList from '../../../../components/News/NewsPromoList/';
import Pagination from '../../../../components/Pagination/Pagination';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';

const navItemsNews = [
    <FormattedMessage id="news.tabs.all_news" defaultMessage="All" />,
    <FormattedMessage id="news.tabs.my_news.theme_3" defaultMessage="For me" />,
];

const navItemsPromo = [
    <FormattedMessage id="news.tabs.all_news" defaultMessage="All" />,
    <FormattedMessage id="news.tabs.my_news.theme_3" defaultMessage="For me" />,
];

const NewsPage = ({
    newsLoading,
    promoLoading,
    cardHeaderRef,
    wmPageCount,
    pageCount,
    newOffersPageCount,
    webmasterNews,
    newOffersNews,
    news,
    data,
    changeNewsPage,
    changeNewOffersNewsPage,
    changeMyNewsPage,
    webmasterPromotions,
    promotions,
}) => {
    const newsPanes = [
        <Fragment>
            <NewsList news={news} groupByDate />
            {pageCount > 1 && (
                <Pagination
                    pageCount={pageCount}
                    onPageChange={changeNewsPage}
                    activePage={data.news.page + 1}
                    scrollToAfterPageChanged={{
                        ref: cardHeaderRef,
                    }}
                />
            )}
        </Fragment>,

        <Fragment>
            <NewsList news={webmasterNews} groupByDate />
            {wmPageCount > 1 && (
                <Pagination
                    pageCount={wmPageCount}
                    onPageChange={changeMyNewsPage}
                    activePage={data.myNews.page + 1}
                    scrollToAfterPageChanged={{
                        ref: cardHeaderRef,
                    }}
                />
            )}
        </Fragment>,
    ];

    const promoPanes = [
        <NewsPromoList promotions={promotions} />,
        <NewsPromoList promotions={webmasterPromotions} />,
    ];

    return (
        <Layout formattedTitle="pages.news.title">
            <Layout.LeftCol xl="8" lg="7">
                <Card.Tabs
                    titleLG={true}
                    className="card-loading-silent news-page-list"
                    title="news.list.title"
                    defaultMessage="News"
                    activeTab={1}
                    navItems={navItemsNews}
                    panes={newsPanes}
                    loading={newsLoading}
                    innerRef={el => (cardHeaderRef = el)}
                />
            </Layout.LeftCol>

            <Layout.RightCol xl="4" lg="5">
                <Card.Tabs
                    titleLG={true}
                    title="news.special.title"
                    defaultMessage="Special offers"
                    activeTab={1}
                    navItems={navItemsPromo}
                    panes={promoPanes}
                    loading={promoLoading}
                    noPadding
                />
            </Layout.RightCol>
        </Layout>
    );
};

export default NewsPage;
